import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Informative cookie-consent banner (RGPD / nLPD compliance).
//
// Bandz only uses strictly essential cookies/localStorage (session auth +
// UI preferences: `bandz.sid`, `bandz-*`, `bandz.locale`, ...). There is NO
// third-party / tracking / analytics cookie, so this is an informational
// banner, NOT a consent wall — the app keeps working without accepting.
//
// The user's choice is persisted in localStorage under `bandz.cookie-consent`
// ('accepted') so it is not re-shown after they accept. Explicitly stored
// preferences win; the banner reappears only if nothing was stored.
const STORAGE_KEY = 'bandz.cookie-consent';

function getInitialAccepted(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'accepted';
  } catch {
    return false;
  }
}

export default function CookieConsent() {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState<boolean>(getInitialAccepted);

  if (accepted) return null;

  function accept() {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      /* ignore storage errors */
    }
    setAccepted(true);
  }

  return (
    <div className="cookie-consent" role="region" aria-label={t('cookieConsent.title')}>
      <p className="cookie-consent-text">{t('cookieConsent.message')}</p>
      <div className="cookie-consent-actions">
        <a
          className="cookie-consent-link"
          href="https://bandzontour.com/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('cookieConsent.moreInfo')}
        </a>
        <button type="button" className="btn btn-primary" onClick={accept}>
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  );
}
